import axios from 'axios';
import { isEmpty } from '.';

const setAuthToken = token => {
   if (token) {
      axios.defaults.headers.common['Authorization'] = token;
      // let ipADD = `${localStorage.getItem('client-ip')}`;
      // let ipaddress = isEmpty(ipADD) ? "42.125.249.228" : (isEmpty(ipADD.split("\n")[2]) == false ? ipADD.split("\n")[2].split("=")[1] : ipADD); 
      // axios.defaults.headers.common['ipAddress'] = ipaddress;
      
      // // axios.defaults.headers.common['cli-url'] = localStorage.getItem('client-ip'); 
      // //console.log(axios.defaults.headers.common)
      // axios.request.
   } else {
      delete axios.defaults.headers.common['Authorization'];
   }
}

export default setAuthToken;


// WEBPACK FOOTER //
// ./src/common/cores/setAuthToken.js